export class AssessmentTypeEdit
{
    public id = null;
    public name = '';
    public active = true;
}

export interface AssessmentTypeList
{
    id: number;
    name: string;
    active: boolean;
    lastModifiedBy: string;
    lastModifiedDate: Date;
}
